import storage from 'key-storage';
import * as types from '../mutation-types';

const state = {
  demo: true,
  country: 'XX',
  device: {
    isMobile: false,
    isTablet: false
  }
};

const getters = {
  app: () => state,
  demo: () => state.demo,
  device: () => state.device,
  country: () => state.country
};

const actions = {
  setCountry: ({ commit }, country) => {
    storage.set('i18n', country);
    commit(types.SET_COUNTRY, country);
  }
};

const mutations = {
  [types.SET_COUNTRY](_, country) {
    state.country = country;
  },
  [types.TOGGLE_DEVICE](_, device) {
    state.device.isMobile = device === 'mobile';
    state.device.isTablet = device === 'tablet';
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js